import React from "react";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import {
  circuit_controller_schema,
  Lamp_test_schema,
  Signal_No_schema,
  six_month_schema,
  TripStopHeader,
  TripStopSchemaGauge,
} from "./TripStopSchema";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import AssetAreaCondition from "../AssetAreaConditionReport";
const masterKey = [
  { key: "C", value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  { key: "G", value: "Governed by Special Instruction." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant." },
  { key: "N", value: "Test Not Applicable." },
];
const TripStopReport = (props) => {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "PATH_GaugeForm",
    "PATH_SixMonthForm",
    "PATH_CircuitControllerForm",
    "PATH_LampForm",
    "PATH_AssetAreaCondition",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => <ViewReport key={i} data={report} {...props} />);
};

const ViewReport = (props) => {
  const { data } = props;
  const { decodedData } = data;
  const gauge = decodedData.find((item) => item.testCode === "PATH_GaugeForm");
  const sixMonth = decodedData.find((item) => item.testCode === "PATH_SixMonthForm");
  const circuit = decodedData.find((item) => item.testCode === "PATH_CircuitControllerForm");
  const revamp = decodedData.find((item) => item.testCode === "PATH_LampForm");

  let tourfound = decodedData.find((e) => (e.otherInfo || {}).tours);
  let tours = tourfound && tourfound.otherInfo.tours;
  let tour = tours && tours[0];
  //  const gaugeReport = reports.find(r => );
  const assetAreaConditionData = decodedData.filter((t) => t.testCode === "PATH_AssetAreaCondition");
  let showReport = assetAreaConditionData.length !== decodedData.length;
  return (
    showReport && (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection title="Overhead Catenary System" {...props} fontSizeOverride={"35px"} />
        <span className="spacer"></span>

        <ReportFraInfoSectionContainer
          {...props}
          data={{ ...data, tourNumber: (tour && tour.name) || (tour && tour.description) || " " }}
        />
        <ReportFraConditionsMasterKey masterKey={masterKey} />

        <div>
          <span className="spacer"></span>
          <AssetAreaCondition data={assetAreaConditionData} />
          {decodedData && (
            <table className="table-bordered">
              {Signal_No_schema.map((section, key) => (
                <ReportTableSectionRenderer key={key} section={section} rowsData={{ assetName: props.selectedAsset }} />
              ))}
              {TripStopHeader.map((section, key) => (
                <ReportTableSectionRenderer key={key} section={section} rowsData={{}} />
              ))}
              {gauge &&
                TripStopSchemaGauge.map((section, key) => (
                  <ReportTableSectionRenderer
                    key={key}
                    section={section}
                    rowsData={{
                      ...gauge.summary,
                      date: gauge.date || "",
                      // assetName: props.selectedAsset,
                    }}
                  />
                ))}

              {sixMonth &&
                six_month_schema.map((section, key) => (
                  <ReportTableSectionRenderer
                    key={key}
                    section={section}
                    rowsData={{
                      ...sixMonth.summary,
                      date: sixMonth.date || "",
                    }}
                  />
                ))}

              {circuit &&
                circuit_controller_schema.map((section, key) => (
                  <ReportTableSectionRenderer
                    key={key}
                    section={section}
                    rowsData={{
                      ...circuit.summary,
                      date: circuit.date || "",
                    }}
                  />
                ))}

              {revamp &&
                Lamp_test_schema.map((section, key) => (
                  <ReportTableSectionRenderer
                    key={key}
                    section={section}
                    rowsData={{
                      ...(revamp.summary || {}),
                      date: revamp.date || "",
                    }}
                  />
                ))}
            </table>
          )}

          <br />
          <p style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            <span>
              <b>Reviewed by (supervisor):</b> ________________________________
            </span>
          </p>
          <br />
          <p>Test Form: SR2-B1 &nbsp; 11/2018</p>
        </div>
      </div>
    )
  );
};

export default TripStopReport;



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TripStopReport/index.jsx